import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import StickyTimer from './StickyTimer';
import CalendlyModal from './CalendlyModal';

const Header: React.FC = () => {
  const [isCalendlyModalOpen, setIsCalendlyModalOpen] = useState(false);
  const location = useLocation();

  const getStickyTimerProps = () => {
    const path = location.pathname;
    
    if (path.includes('webinar')) {
      return { type: 'webinar' as const, page: 'revenue' as const };
    }
    
    if (path === '/revenue') return { type: 'consultation' as const, page: 'revenue' as const };
    if (path === '/productivity') return { type: 'consultation' as const, page: 'productivity' as const };
    if (path === '/retention') return { type: 'consultation' as const, page: 'retention' as const };
    if (path === '/thank-you') return null;
    
    return { type: 'consultation' as const, page: 'revenue' as const };
  };

  const stickyTimerProps = getStickyTimerProps();
  const isWebinarPage = location.pathname.includes('webinar');

  return (
    <>
      <motion.header 
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white shadow-lg sticky top-0 z-40"
      >
        <div className="max-w-7xl mx-auto px-6">
          <div className={`flex items-center py-4 ${isWebinarPage ? 'justify-center' : 'justify-between'}`}>
            {/* Logo */}
            <img src={`${window.location.origin}/logo-zylu.webp`} alt="Zylu Logo" className="h-[60px] bg-black" />

          </div>
        </div>
      </motion.header>
      
      {stickyTimerProps && <StickyTimer {...stickyTimerProps} />}

      {/* Calendly Modal */}
      <CalendlyModal
        isOpen={isCalendlyModalOpen}
        onClose={() => setIsCalendlyModalOpen(false)}
        url="https://calendly.com/zylusales/zylu-growth-demo-free?hide_gdpr_banner=1"
        title="Schedule Your Free Consultation"
      />
    </>
  );
};

export default Header;